/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorLogCompassCreate,
  ErrorLogCompassDeleteAllObjects,
  ErrorLogCompassOnAzure,
} from '../models/index';
import {
    ErrorLogCompassCreateFromJSON,
    ErrorLogCompassCreateToJSON,
    ErrorLogCompassDeleteAllObjectsFromJSON,
    ErrorLogCompassDeleteAllObjectsToJSON,
    ErrorLogCompassOnAzureFromJSON,
    ErrorLogCompassOnAzureToJSON,
} from '../models/index';

export interface ApiErrorLogsCompassAddPostRequest {
    errorLogCompassCreate?: ErrorLogCompassCreate;
}

export interface ApiErrorLogsCompassDeleteAllObjectsDeleteRequest {
    errorLogCompassDeleteAllObjects?: ErrorLogCompassDeleteAllObjects;
}

export interface ApiErrorLogsCompassGetAllByVersionGetRequest {
    firmwareVersion?: string;
}

/**
 * 
 */
export class ErrorLogsCompassApi extends runtime.BaseAPI {

    /**
     */
    async apiErrorLogsCompassAddPostRaw(requestParameters: ApiErrorLogsCompassAddPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ErrorLogCompassOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/ErrorLogsCompass/Add`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErrorLogCompassCreateToJSON(requestParameters['errorLogCompassCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ErrorLogCompassOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiErrorLogsCompassAddPost(requestParameters: ApiErrorLogsCompassAddPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ErrorLogCompassOnAzure> {
        const response = await this.apiErrorLogsCompassAddPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiErrorLogsCompassDeleteAllObjectsDeleteRaw(requestParameters: ApiErrorLogsCompassDeleteAllObjectsDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/ErrorLogsCompass/DeleteAllObjects`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: ErrorLogCompassDeleteAllObjectsToJSON(requestParameters['errorLogCompassDeleteAllObjects']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiErrorLogsCompassDeleteAllObjectsDelete(requestParameters: ApiErrorLogsCompassDeleteAllObjectsDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiErrorLogsCompassDeleteAllObjectsDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiErrorLogsCompassGetAllByVersionGetRaw(requestParameters: ApiErrorLogsCompassGetAllByVersionGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        if (requestParameters['firmwareVersion'] != null) {
            queryParameters['firmware_version'] = requestParameters['firmwareVersion'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/ErrorLogsCompass/GetAllByVersion`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async apiErrorLogsCompassGetAllByVersionGet(requestParameters: ApiErrorLogsCompassGetAllByVersionGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.apiErrorLogsCompassGetAllByVersionGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
